import { Alert, Modal, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { TppProofDisplayKind } from '../../../services/systems/transit-pass-pool/tppProofFile';
import { TPP_MODAL_CONTENT_CLASS } from './tppUiShared';

type TppProofViewerModalProps = {
  closeLabel: string;
  open: boolean;
  onHide: () => void;
  loading: boolean;
  error: string | null;
  fileUrl: string | null;
  displayKind: TppProofDisplayKind | null;
  fileName?: string | null;
};

/** 利用証明（画像・PDF 等）の表示 */
export default function TppProofViewerModal({
  closeLabel,
  open,
  onHide,
  loading,
  error,
  fileUrl,
  displayKind,
  fileName,
}: TppProofViewerModalProps) {
  const { t } = useTranslation();
  const kind = displayKind ?? 'other';

  return (
    <Modal
      show={open}
      onHide={onHide}
      centered
      size="lg"
      contentClassName={TPP_MODAL_CONTENT_CLASS}
    >
      <Modal.Header closeButton closeLabel={closeLabel}>
        <Modal.Title>{t('tpp.proof_view_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {loading && (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">{t('common.loading')}</span>
          </Spinner>
        )}
        {error && <Alert variant="danger">{error}</Alert>}
        {fileUrl && !loading && !error && kind === 'image' && (
          <img
            src={fileUrl}
            alt=""
            className="img-fluid rounded border"
            style={{ maxHeight: '70vh' }}
          />
        )}
        {fileUrl && !loading && !error && kind === 'pdf' && (
          <iframe
            src={fileUrl}
            title={t('tpp.proof_view_title')}
            className="rounded border w-100"
            style={{ height: '70vh', border: 0 }}
          />
        )}
        {fileUrl && !loading && !error && kind === 'other' && (
          <div className="py-3">
            <p className="text-muted mb-3">{t('tpp.proof_open_external_hint')}</p>
            {fileName ? (
              <p className="small mb-3 text-break">{fileName}</p>
            ) : null}
            <a
              href={fileUrl}
              download={fileName || true}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              {t('tpp.proof_open_file')}
            </a>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
